import { render } from "./commisions.vue?vue&type=template&id=9459e3e2"
import script from "./commisions.vue?vue&type=script&lang=js"
export * from "./commisions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__